// import Page Components
import React from 'react'
import Home from '../Views/Home/Home'
import HomeZones from '../Views/Home/HomeZones'
// import Company from '../Views/Company/Company'
import NoMatch from '../Views/NoMatch/NoMatch'

// import Page Content
import { home } from './homePage'
import { zones } from './homePageZones'
import { map } from './mapPage'
import { location } from './locationPage'
import { company } from './companyPage'

const routes = [
  {
    name: 'Trust Zone',
    path: '/',
    viewComponent: HomeZones,
    type: 'INTERNAL-LOGO',
    description: '',
    content: zones,
    category: 'HOME'
  },
  {
    name: 'About',
    path: '/about',
    viewComponent: Home,
    type: 'INTERNAL-NORMAL',
    description: '',
    content: home,
    category: 'HOME'
  },
  {
    name: <img src="/publicAssets/linkLocation.svg" alt="" />,
    title: 'Location',
    path: '/location',
    viewComponent: Home,
    selectedColor: '#27AE60',
    type: 'INTERNAL-NORMAL',
    description: '',
    content: location,
    category: 'HOME'
  },
  {
    name: <span style={{ color: '#3083E9' }}>FOAM Map</span>,
    title: 'Map',
    path: '/map',
    viewComponent: Home,
    selectedColor: '#3083E9',
    type: 'INTERNAL-NORMAL',
    description: '',
    content: map,
    category: 'HOME'
  },
  {
    name: 'Company',
    path: '/company',
    viewComponent: Home,
    selectedColor: 'currentColor',
    type: 'INTERNAL-NORMAL',
    description: '',
    content: company,
    category: ''
  },
  {
    name: 'Community',
    path: null,
    children: [
      {
        name: 'Blog',
        path: 'https://mirror.xyz/foamspace.eth',
        viewComponent: NoMatch,
        type: 'EXTERNAL-NORMAL',
        description: '',
        content: null,
        category: 'COMMUNITY'
      },
      {
        name: 'Farcaster',
        path: 'https://warpcast.com/~/channel/foam',
        viewComponent: NoMatch,
        type: 'EXTERNAL-NORMAL',
        description: '',
        content: null,
        category: 'COMMUNITY'
      },
      {
        name: 'Twitter',
        path: 'https://twitter.com/foamspace',
        viewComponent: null,
        type: 'EXTERNAL-NORMAL',
        description: '',
        content: null,
        category: 'COMMUNITY'
      }
    ],
    viewComponent: null,
    type: 'TEXT',
    description: '',
    content: null,
    category: ''
  },
  {
    name: 'Learn',
    path: null,
    children: [
      {
        name: 'Whitepaper',
        path: '/publicAssets/FOAM_Whitepaper.pdf',
        viewComponent: null,
        type: 'EXTERNAL-NORMAL',
        description: '',
        content: null,
        category: 'LOCATION',
        isWhitepaper: true
      },
      {
        name: 'Trust Zone FAQ',
        path:
          'https://mirror.xyz/foamspace.eth/9QRjUNdAuw80x9CLvMs76hEp-LVpV92CXVyGmC0H4fU',
        viewComponent: null,
        type: 'EXTERNAL-NORMAL',
        description: '',
        content: null,
        category: 'LOCATION',
        isWhitepaper: false
      },
      {
        name: 'Developer',
        path: 'https://developer.foam.space',
        viewComponent: null,
        type: 'EXTERNAL-NORMAL',
        description: '',
        content: null,
        category: 'MAP'
      },
      {
        name: 'Blog',
        path: 'https://mirror.xyz/foamspace.eth',
        viewComponent: NoMatch,
        type: 'EXTERNAL-NORMAL',
        description: '',
        content: null,
        category: 'COMMUNITY'
      },
      {
        name: 'Farcaster',
        path: 'https://warpcast.com/~/channel/foam',
        viewComponent: NoMatch,
        type: 'EXTERNAL-NORMAL',
        description: '',
        content: null,
        category: 'COMMUNITY'
      }
    ],
    viewComponent: null,
    type: 'TEXT',
    description: '',
    content: null,
    category: 'HOME'
  },
  {
    name: '404',
    path: '*',
    viewComponent: NoMatch,
    type: 'NOMATCH',
    description: '',
    content: null,
    category: 'UTIL'
  }
]

const lesserRoutes = [
  {
    name: 'Team',
    path: '/company',
    viewComponent: Home,
    type: 'INTERNAL-NORMAL',
    description: '',
    content: company,
    category: 'COMPANY'
  },
  {
    name: 'Dapp',
    path: 'https://map.foam.space',
    viewComponent: NoMatch,
    type: 'EXTERNAL-NORMAL',
    description: '',
    content: null,
    category: 'MAP'
  },
  {
    name: 'Tools',
    path: 'https://foam.tools/#/',
    viewComponent: NoMatch,
    type: 'EXTERNAL-NORMAL',
    description: '',
    content: null,
    category: 'MAP'
  },
  {
    name: 'Technical Paper',
    path:
      'https://github.com/f-o-a-m/public-research/blob/master/FOAM%20Techincal%20Whitepaper%20Draft.pdf',
    viewComponent: null,
    type: 'EXTERNAL-NORMAL',
    description: '',
    content: null,
    category: 'LOCATION',
    isWhitepaper: true
  },
  {
    name: 'Github',
    path: 'https://github.com/f-o-a-m/',
    viewComponent: null,
    type: 'EXTERNAL-NORMAL',
    description: '',
    content: null,
    category: 'LOCATION'
  },
  // {
  //   name: 'Blog',
  //   path: 'https://blog.foam.space/',
  //   viewComponent: NoMatch,
  //   type: 'EXTERNAL-NORMAL',
  //   description: '',
  //   content: null,
  //   category: 'COMMUNITY'
  // },
  {
    name: 'Careers',
    path: 'https://jobs.lever.co/foam',
    viewComponent: null,
    type: 'EXTERNAL-NORMAL',
    description: '',
    contenct: null,
    category: 'COMPANY'
  }
  // {
  //   name: 'LinkedIn',
  //   path: 'https://www.linkedin.com/company/10965775/',
  //   viewComponent: null,
  //   type: 'EXTERNAL-NORMAL',
  //   description: '',
  //   content: null,
  //   category: 'COMPANY'
  // },
  // {
  //   name: 'AngelList',
  //   path: 'https://angel.co/foam_protocol/',
  //   viewComponent: null,
  //   type: 'EXTERNAL-NORMAL',
  //   description: '',
  //   content: null,
  //   category: 'COMPANY'
  // },
]

export { routes, lesserRoutes }



// WEBPACK FOOTER //
// ./src/content/routes.js